<template>
  <div
    v-if="address && getAddressFormatted(address)"
    class="--text-no-wrap--"
  >
    <v-icon
      v-if="icon"
      :color="address.IsDefault ? 'light-green lighten-1' : 'grey'"
      :size="iconSize"
      class="mr-1"
    >
      {{ getAddressType(address)?.Icon || 'location_on' }}
    </v-icon>

    <template v-if="address.Type === AddressTypeEnum.DEFAULT">
      <span>{{ getAddressFormatted(address) }}</span>
    </template>

    <template v-else-if="address.Type === AddressTypeEnum.INTERNAL_OFFICE">
      <span v-if="address?.ExtraFields?.building"><strong>{{ $t('Customer.CustomerAddEditAddressDialog.Field.Building.Label') }}:</strong> {{ address?.ExtraFields?.building }}&nbsp;</span>
      <span v-if="address?.Floor"><strong>{{ $t('Customer.CustomerAddEditAddressDialog.Field.Floor.Label') }}:</strong> {{ address?.Floor }}&nbsp;</span>
      <span v-if="address?.ExtraFields?.office"><strong>{{ $t('Customer.CustomerAddEditAddressDialog.Field.Office.Label') }}:</strong> {{ address?.ExtraFields?.office }}&nbsp;</span>
      <span v-if="address?.ExtraFields?.department"><strong>{{ $t('Customer.CustomerAddEditAddressDialog.Field.Department.Label') }}:</strong> {{ address?.ExtraFields?.department }}&nbsp;</span>
      <span v-if="address?.ExtraFields?.Reception"><strong>{{ $t('Customer.CustomerAddEditAddressDialog.Field.Reception.Label') }}:</strong> {{ address?.ExtraFields?.Reception }}&nbsp;</span>
    </template>

    <template v-else>
      {{ getAddressFormatted(address) }}
    </template>
  </div>
</template>

<script>

import AddressCommon from '@/mixins/maps/addressCommon.js'
import AddressTypeEnum from '@/api/Enums/AddressTypeEnum.js'

export default {
  name      : 'AddressDisplay',
  components: {},
  directives: {},
  mixins    : [AddressCommon],
  props     : {
    address: {
      type   : Object,
      default: undefined
    },

    icon: {
      type   : Boolean,
      default: false
    },

    iconSize: {
      type   : [Number, String],
      default: 14
    }
  },
  data() {
    return {}
  },
  computed: {
    AddressTypeEnum() {
      return AddressTypeEnum
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
</script>

<style scoped>

</style>
